<template>
<!-- 経費 -->
<div>
  <CCard>
    <CCardHeader><h2>通勤費精算(仮払申請) 詳細</h2></CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="3">
          対象月
        </CCol>
        <CCol sm="4">
          {{year}} 年 {{ month }} 月
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          申請ユーザ名
        </CCol>
        <CCol sm="4">
          {{user_name}}
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          更新日時
        </CCol>
        <CCol sm="4">
          {{updated_at}}
        </CCol>
      </CRow>
    </CCardBody>
    <CCardHeader><strong>通勤費</strong></CCardHeader>
    <CCardBody>
      <ExpenseError ref="error" :day1="day1" :request_type="request_type" :origin="origin" :destination="destination" :route="route" :cost="cost" :remarks="remarks"></ExpenseError>
      <CRow>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th class="title" nowrap style="min-width:120px; white-space:nowrap;"><label>プロジェクト名</label></th>
                <th class="title" nowrap><label>金額&nbsp;(仮払)</label></th>
                <th class="title" nowrap style="min-width:100px; white-space:nowrap;"><label>内訳(備考)</label></th>
                <th class="title" nowrap style="min-width:120px; white-space:nowrap;"><label>交通機関</label></th>
                <th class="title" nowrap><label>出発</label></th>
                <th class="title" nowrap><label>到着</label></th>
                <th class="title" nowrap><label>支払日</label></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(n,index) in lists1" :key="index">
                <td class="ruled-line" nowrap>
                  <span>{{ project_name[index] }}</span>
                </td>
                <td class="ruled-line" nowrap>
                  <span>{{ formatCurrency(cost[index]) }}</span>
                  <span>&nbsp;({{ formatCurrency(temporary[index]) }})</span>
                </td>
                <td class="ruled-line" nowrap>
                  <span>{{ remarks[index] }}</span>
                </td>
                <td class="ruled-line" nowrap>
                  <span>{{ route[index] }}</span>
                </td>
                <td class="ruled-line" nowrap>
                  <span>{{ origin[index] }}</span>
                </td>
                <td class="ruled-line" nowrap>
                  <span>{{ destination[index] }}</span>
                </td>
                <td class="ruled-line" nowrap>
                  <span>
                    {{ year }}/{{ month.toString().padStart(2,'0') }}/{{ day1[index].toString().padStart(2,'0') }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CRow>
    </CCardBody>
    <CCardHeader><strong>合計支払額</strong></CCardHeader>
    <CCardBody>
      <CRow>
        <table class="table">
        <thead>
          <tr>
            <th class="title"><label>通勤費合計</label></th>
            <th class="title"><label>仮払小計</label></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <!--通勤費合計-->
            <td class="frame-line">
              <span>{{ totalCost }}</span>
            </td>
            <!--仮払小計-->
            <td class="frame-line">
              <span>{{ totalTemporary }}</span>
            </td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th class="title" colspan="2"><label>差引戻・払額</label></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <!--差引戻・払額-->
            <td class="frame-line" colspan="2">
              <span>{{ sumPayment }}</span>
            </td>
          </tr>
        </tbody>
        </table>
      </CRow>
    </CCardBody>
  </CCard>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import ConstList from './../../ConstList'
import { requestFailureMessage } from '@/utils/requestFailure'
import { leaveWhenDetailIsRefused } from '@/utils/detailReadRefused'
import ExpenseError from './ExpenseError'
export default {
  name: 'Expense',
  components: {
    ExpenseError,
  },
  data() {
    return {
      num1: 0,
      num2: 0,
      user_id: 0,
      user_name: '',
      updated_at: '',
      year: '',
      month: '',
      project: '',
      projectList: [],
      name: '',
      days: [],
      project_name: [],
      day1: [],
      request_type: [],
      origin: [],
      destination: [],
      route: [],
      cost: [],
      remarks: [],
      temporary: [],
      calculate: [],
      sum_transport: [],
      sum_expense: [],
      sum_stay: [],
      sum_commute: [],
      sum_cost: [],
      sum_temporary: [],
      total: []
    }
  },

  methods: {
    // DBから一覧呼出メソッド
    callList: function () {
      const params = new URLSearchParams()
      this.user_id = this.$route.params.user_id
      this.year = this.$route.params.year
      this.month = this.$route.params.month
      params.append('user_id', this.user_id)
      params.append('year', this.year)
      params.append('month', this.month)
      axios.get((process.env.VUE_APP_API_ORIGIN) + '/admin/commuteSelect', {
        params: {
          user_id: this.user_id,
          year: this.year,
          month: this.month
        }
      }).then(response => {
        this.num1 = 0
        this.num2 = 0
        this.project_name = []
        this.day1 = []
        this.request_type = []
        this.origin = []
        this.destination = []
        this.route = []
        this.cost = []
        this.remarks = []
        this.days = []
        this.temporary = []
        const start = moment(this.year + "-" + this.month + '-01').startOf('month')
        const end = moment(this.year + '-0' + this.month + '-01').endOf('month')
        while (start.unix() <= end.unix()) {
          this.days.push(start.format('D'))
          start.add(1, 'days')
        }
        response.data.forEach(element => {
          this.num1++
            this.project_name.push(element.project_name)
          this.day1.push(element.date.substring(8).replace(/^0+/, ''))
          this.request_type.push(element.request_type)
          this.origin.push(element.origin)
          this.destination.push(element.destination)
          this.route.push(element.route)
          // 金額・仮払が入っていない明細（本番は空を許す）は空欄として持ち、0円として数える。
          // 「null」の文字を入れていたので、合計・差引が ￥NaN になっていた。
          this.cost.push(element.cost == null ? "" : element.cost + "")
          this.remarks.push(element.remarks)
          this.temporary.push(element.temporary == null ? "" : element.temporary + "")
          this.user_name = element.user_name
          this.updated_at = element.updated_at
        });
      }).catch(error => {
        // 読み込みを断られたら、空の画面を残さず断りの画面へ移す。
        if (leaveWhenDetailIsRefused(this.$router, error)) return
        axios
        .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
        .then(() => {
          alert(requestFailureMessage(error));
        })
        .catch(() => {
          alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
        })
      })
    },
    // 金額3桁ごとにカンマを付けるメソッド
    addComma: function (value) {
      const list = value
      for (let i = 0; i < list.length; i++) {
        const comma = list[i].toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,')
        list.splice(i, 1, comma)
        if ((comma === 0) || (comma === null) || (comma === '')) {
          list.splice(i, 1, '')
        }
      }
    },
    // カンマ付加と金額のエラーチェックメソッド(経費)
    addCost: function () {
      this.$refs.error.cost_empty()
      this.addComma(this.cost)
      this.$refs.error.cost_regex()
    },
    // カンマ付加メソッド(仮払)
    addTemporary: function () {
      this.$refs.error2.temporary_empty()
      this.addComma(this.temporary)
      this.$refs.error2.temporary_regex()
    },
    // フォーカスが当たるとカンマを外すメソッド
    deleteComma: function (value) {
      const list = value
      for (let i = 0; i < list.length; i++) {
        const comma = list[i].replace(/,/g, '')
        list.splice(i, 1, comma)
        if ((comma === 0) || (comma === null) || (comma === '')) {
          list.splice(i, 1, '')
        }
      }
    },
    // カンマ除去メソッド(経費)
    deleteCost: function () {
      this.deleteComma(this.cost)
    },
    // カンマ除去メソッド(仮払)
    deleteTemporary: function () {
      this.deleteComma(this.temporary)
    },
    // 申請区分名称変換
    getRequestTypeName(typeId) {
        const option = this.options.find(o => o.id === typeId);
        return option ? option.name : typeId;
    },
    // 各項目の金額フォーマット変換
    formatCurrency(value) {
      if (!value) return '￥0';
      const num = parseInt(String(value).replace(/,/g, '')) || 0;
      return '￥' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
  },

  computed: {
    // 通勤費合計の計算
    totalCost: function () {
      const list = this.cost
      const sum = this.sum_cost
      let result = 0
      for (let i = 0; i < list.length; i++) {
        const data = list[i].replace(/,/g, '')
        if(data) {
          const cal = parseInt(data)
          result = result + cal
        }
      }
      sum.splice(0, 1, result)
      return '￥' + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,')
    },
    // 仮払小計の計算
    totalTemporary: function () {
      const list = this.temporary
      const sum = this.sum_temporary
      let result = 0
      for (let i = 0; i < list.length; i++) {
        const data = list[i].replace(/,/g, '')
        if(data) {
          const cal = parseInt(data)
          result = result + cal
        }
      }
      sum.splice(0, 1, result)
      return '￥' + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,')
    },
    // 差引戻・払額の計算。本人の画面（request/payoff/TravelCost.vue）と同じ出し方にそろえる。
    // 配列どうしの引き算にしていたので、合計が数にならないと ￥NaN を出していた。
    sumPayment: function () {
      const cost = Number(this.sum_cost?.[0]) || 0
      const total = this.total
      const temporary = Number(this.sum_temporary?.[0]) || 0
      const sum = cost - temporary
      total.splice(0, 1, sum)
      return '￥' + sum.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,')
    },
    // 入力欄を追加・削除出来るようにする(経費)
    lists1: function () {
      return Array.from(Array(this.num1).keys())
    },
  },

  mounted: function () {
    const today = moment()
    this.year = today.format('YYYY')
    this.month = today.format('M')
    this.day1.splice(0, 1, "")
    this.request_type.splice(0, 1, "")
    this.origin.splice(0, 1, "")
    this.destination.splice(0, 1, "")
    this.route.splice(0, 1, "")
    this.cost.splice(0, 1, "")
    this.remarks.splice(0, 1, "")
    this.temporary.splice(0, 1, "")

    this.callList()
  }
}
</script>

<style scoped>
select {
  margin-bottom: 16px;
}

table {
  margin: 0px 20px;
}

.title{
  border: solid 1px gray;
}

td{
  padding-bottom:0px;
}

th, td {
  border-right: 1px solid #d8dbe0;
}

.ruled-line{
  border-bottom: 1px solid #d8dbe0;
}

.frame-line{
  border: 1px solid #d8dbe0;
}


button:disabled {
  cursor: not-allowed;
}
</style>
